import React, { FC, Suspense } from 'react';
import { MicroBundle } from '@vtblife/micro-frontend-core';
import { History } from 'history';
import { observer } from 'mobx-react';

import { BundleTreeStore } from '../../stores/bundle-tree';
import { ConfigStore } from '../../stores/config';
import { UserStore } from '../../stores/user';
import { ErrorBoundary } from '../error-boundary/error-boundary';

export interface SuspenseMicroAppProps {
    initialState: InitialState;
    history: History;
    userStore: UserStore;
    configStore: ConfigStore;
    bundleTreeStore: BundleTreeStore;
    [key: string]: any;
}

export const SuspenseMicroApp: FC<SuspenseMicroAppProps & { appName: string }> = observer(
    ({ initialState, history, bundleTreeStore, configStore, userStore, appName, ...props }) => {
        const route = bundleTreeStore.bundleTreeRoutes.find((route) => route.applicationName === appName);
        if (!route) return null;
        return (
            <Suspense fallback={<></>}>
                {/* @ts-expect-error */}
                <ErrorBoundary
                    extraInfo={{
                        user: userStore.toJS(),
                        config: configStore.toJS(),
                        bundleTreeRoutes: bundleTreeStore.bundleTreeRoutes,
                    }}
                >
                    <MicroBundle
                        name={route.applicationName}
                        path={route.assetsUrl || configStore.getApplicationPath(route.applicationName)}
                        basePath={route.path}
                        history={history}
                        authInfo={userStore.toJS()}
                        config={configStore.toJS()}
                        initialState={initialState}
                        {...props}
                    />
                </ErrorBoundary>
            </Suspense>
        );
    },
);
